import { FlowstepStorage } from '@v2/services/flowsteps/flowstep-storage';
import HubspotStore from '@v2/stores/hubspotStore';
import RequestStore from '@v2/stores/requestStore';
import UserStore from '@v2/stores/userStore';
import { MobXProviderContext } from 'mobx-react';
import { useContext } from 'react';
import DataStore from 'src/stores/dataStore';
import OfficeStore from 'src/stores/officeStore';

interface StoresContext {
  hubspotStore: HubspotStore;
  flowstepStorage: FlowstepStorage;
  dataStore: DataStore;
  officeStore: OfficeStore;
  requestStore: RequestStore;
  userStore: UserStore;
}

export const useStores = (): StoresContext => {
  return useContext(MobXProviderContext) as StoresContext;
};
